import { getCookie, getDisplayedTabUID, handleLogout, reversibleHash } from "../oro-module/commonFunctions";
import uuid from "uuid";
import {remoteip} from "../../config"
const axios = require("axios");

// allrequests={};
// const httpRequest = () => {
//   const Http = new XMLHttpRequest();
//   const url = 'https://jsonplaceholder.typicode.com/posts';
//   Http.open("GET", url);
//   Http.send();

//   Http.onreadystatechange = (e) => {
//     console.log(Http.responseText)
//   }
// }



const fetchData = async ({ url, postData, method = "post", headers, cbf, current, dontencrypt = false }) => {

  let lgs, x;
  let notifications;
  let response;
  let reqStart = new Date().getTime();

  let tmppd = new Object(postData);

  if ((!headers || !headers.Authorization) && current && current.props && current.props.parentProps && current.props.parentProps.parentState && current.props.parentProps.parentState.token) {
    headers = { Authorization: `JWT ${current.props.parentProps.parentState.token}` };
    headers['Cache-Control'] = 'max-stale';
  }


  if (current) {
    let { profile } = current.props.parentProps.parentState;
    if (profile) {
      postData['portal'] = profile.portal;
      postData['portal_scheme'] = profile.portal_scheme;
    }
  }

  if (current) {
    lgs = current.props.liftGlobalState;
    // lgs({ name: "directloading" }, "Please wait . . .");
    let { remoteip } = current.props.parentState;
    // console.log("REMOTE IP")
    // console.log(remoteip)

    if (url == 'cbsurl' || url == `${remoteip}/sentry`) {
      //alert(remoteip)
      url = `${remoteip}/sentry`;
    } else if (url == 'clientdata') {
      url = `${remoteip}/clientdata`;
    }
  }

  let searchTime = 0;
  try {
    // switch (method) {
    //   case 'get':
    //     response = await axios.get(url);
    //   case 'post':
    //     response = await axios.post(url, postData, { headers });
    // }
    if (method.toLowerCase() == 'get') {
      response = await axios.get(url);

    } else if (method.toLowerCase() == 'post') {
      // check current displayed tabs. Get their uid. see if any other data exists with "." in it. Remove it.
      let poda = {};
      let tab_uids = getDisplayedTabUID();

      if (tab_uids) {
        let pageD = postData.pageData;
        for (var key in pageD) {
          if (key.indexOf(".") != -1) {
            let tid = key.split(".")[0];
            if (tab_uids[tid] == 1) {
              poda[key] = pageD[key];
            }
          } else {
            poda[key] = pageD[key];
          }
        }
        postData.pageData = poda;
      }

      postData.gui_uuid = uuid.v4();


      if (postData.pageData.auth_action == 'revert') {
        postData.pageData.revert_reason = prompt("Enter reason for revert (OPTIONAL)");
      }
      // debugger;
      console.log({ postData, url, headers });

      if (dontencrypt) {
        response = await axios.post(url, postData, { headers });
      } else {
        postData = reversibleHash(JSON.stringify(postData));
        response = await axios.post(url, { data: postData }, { headers });
      }
    }

    searchTime = new Date().getTime() - reqStart;

    if (current) {
      lgs = current.props.liftGlobalState;
      lgs({ name: "directloading" }, false);
    }

    const returned = response.data;
    const should_logout = returned ? returned.logout : false;
    // console.log({ returned });
    // debugger;

    try {
      returned.searchTime = searchTime;
    }
    catch (e) { }

    if (current) {
      if (typeof response == 'string' || should_logout) {
        notifications = { value: "Session expired", alertType: "error" };
        handleLogout(current);
        lgs({ name: 'notifications' }, notifications);
        let logoutbtn = document.getElementById("logout-button-hidden");
        if (logoutbtn) {
          setTimeout(() => logoutbtn.click(), 10);
        }
        return false;
      }
      else if (typeof returned == 'string') {
        // Handle errors.
        notifications = { value: "Session expired", alertType: "error" };
        handleLogout(current);
        // alert(returned);
        lgs({ name: 'notifications' }, notifications);
        let logoutbtn = document.getElementById("logout-button-hidden");
        if (logoutbtn) {
          setTimeout(() => logoutbtn.click(), 10);
        }
        return false;
        // return { error: "Session expired" };
      } else {
        let { error, exceptions, message, authenticated, logout } = returned;
        if (error) {
          let perr;
          if (!error.message) {
            perr = error;
          }
          else if (error.message) {
            perr = error.message;
          } else {
            perr = "Can not connect to the main server";
          }
          if (current && current.props.parentProps.parentState.identi) {
            if (perr != 'No such record found.') {
              alert(perr);
              console.log(155);
            }
          } else {
            notifications = { value: ` ${error.code ? 'Error No:' + error.code + '.' : ''} ${perr.substring(0, 200)}`, alertType: "warning" };
            lgs({ name: 'notifications' }, notifications);
          }

          cbf ? cbf({ error: perr }) : x = 1;
          if (logout) {
            handleLogout(current);
          }

          return { error };
        }
        else if (authenticated) {
          returned.success = true;
          cbf ? cbf(returned) : x = 1;
          return returned;
        }
        else if (message) {
          cbf ? cbf(returned) : x = 1;
          notifications = { value: message, alertType: "success" };
          lgs({ name: 'notifications' }, notifications);
          return { error: message, returned };
        }
        else {
          returned.success = true;
          cbf ? cbf(returned) : x = 1;
          lgs({ name: 'notifications' }, {});
          console.log({ returned });
          return returned;
        }
      }
    } else {
      cbf ? cbf(returned) : x = 1;
      return returned;
    }
  } catch (error) {
    if (current) {
      notifications = { value: error ? error : "Can not connect to the main server", alertType: "error" };
      lgs({ name: 'notifications' }, notifications);
      return {};
    }
    cbf ? cbf({ error }) : x = 1;
    return { error };
  }

};


const ajaxValidate = async ({ value, fieldName, liveValidation, current }) => {
  let { pageData, currentPage } = current.props.parentState;
  let saveThis = { value, fieldName, currentPage, others: {}, dataType: "liveValidate" };
  liveValidation.map(lv => saveThis['others'][lv] = pageData[lv]);

  let response = await fetchData({ url: 'cbsurl', postData: saveThis, method: 'post', current });
  // console.log({ response })

  // show errors, warnings.
  // populate data.
  // show / hide action buttons.
}

export { fetchData, ajaxValidate };
